<template>
    <div v-if="application">
        <kt-panel>
            <kt-panel-body>
                <form id="update_application_form">
                    <kt-row>
                        <kt-col xs="12" sm="6">
                            <kt-form-group>
                                <kt-form-label for="title">
                                    {{ $t('application.title') }}
                                </kt-form-label>
                                <kt-form-control dir="rtl" v-model="application.title" name="title"
                                                 id="title"></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col v-if="application.status == applicationStatus.ACTIVE" xs="12" sm="6">
                            <kt-form-group>
                                <kt-form-label for="access_password">
                                    {{ $t('application.access_password') }}
                                </kt-form-label>
                                <kt-form-control dir="ltr" v-model="application.access_password"
                                                 name="access_password"
                                                 disabled id="access_password"></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col v-if="application.status == applicationStatus.ACTIVE" xs="12" sm="6">
                            <kt-form-group>
                                <kt-form-label for="created_at">
                                    {{ $t('label.created_at') }}
                                </kt-form-label>
                                <kt-form-control dir="ltr" v-model="application.created_at" name="created_at"
                                                 disabled id="created_at"></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col v-if="application.status == applicationStatus.ACTIVE" xs="12" sm="6">
                            <kt-form-group>
                                <kt-form-label for="api_key">
                                    {{ $t('application.api_key') }}
                                </kt-form-label>
                                <kt-form-control dir="ltr" v-model="application.api_key" name="api_key"
                                                 disabled id="api_key"></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col v-if="application.status == applicationStatus.ACTIVE" xs="12" sm="6">
                            <kt-form-group>
                                <kt-form-label for="api_key_expire_date">
                                    {{ $t('application.api_key_expire_date') }}
                                </kt-form-label>
                                <kt-form-control dir="ltr" v-model="application.api_key_expire_date"
                                                 name="api_key_expire_date"
                                                 disabled id="api_key_expire_date"></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col v-if="application.status == applicationStatus.ACTIVE" xs="12" sm="6">
                            <kt-form-group>
                                <kt-form-label for="refresh_token">
                                    {{ $t('application.refresh_token') }}
                                </kt-form-label>
                                <kt-form-control dir="ltr" v-model="application.refresh_token" name="refresh_token"
                                                 disabled id="refresh_token"></kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col xs="12" sm="6">
                            <kt-form-group style="margin-top: 34px" class=" col-xs-12 col-sm-8">
                                <p style="display: inline-block"> {{ $t('label.status') + ' : ' }} </p>
                                <div style="display: inline-block;margin-right: 5px"
                                     :class="'badge badge-'+applicationStatusVariant(application.status)+' text-white'">
                                    {{ applicationStatusStr.get(application.status) }}
                                </div>

                            </kt-form-group>
                        </kt-col>
                        <kt-col style="margin-top: 6px" xs="8" sm="8">
                            <kt-col></kt-col>
                            <kt-form-action class="mt-4">
                                <button
                                        class="btn btn-md btn-primary btn-wide"
                                        type="button"
                                        data-toggle="modal"
                                        data-target="#access-ips-modal"
                                        id="access_ips_btn"
                                >
                                    {{ $t('application.access_ips') }}
                                </button>
                            </kt-form-action>

                            <!--                             Modal-->
                            <div id="access-ips-modal" class="modal fade" role="dialog"
                            >
                                <div class="modal-dialog">
                                    <!-- Modal content-->
                                    <div class="modal-content" id="access-ips-modal-content">
                                        <div class="modal-header">
                                            <h4 class="modal-title">
                                                {{ $t('application.access_ips') }}
                                            </h4>
                                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                        </div>
                                        <div class="modal-body">

                                            <div v-for="(access_ip,index) in application.access_ips" :key="index">
                                                <kt-row>
                                                    <kt-col xs="9" sm="9">
                                                        <kt-form-group>
                                                            <kt-form-control :value="access_ip" dir="ltr"
                                                                             :name="'access_ips.'+index"
                                                                             v-model="application.access_ips[index]"
                                                                             :id="index"></kt-form-control>
                                                        </kt-form-group>
                                                    </kt-col>
                                                    <kt-col xs="3" sm="3">
                                                        <kt-form-group>
                                                            <a @click="deleteAccessIp(index)"
                                                               class="w-100 h-100 p-2 pt-3 btn-sm btn btn-label-danger btn-bold float-right">
                                                                <i class="la la-trash-o"></i>
                                                                {{ $t('btn.delete') }}
                                                            </a>
                                                        </kt-form-group>
                                                    </kt-col>
                                                </kt-row>
                                            </div>
                                            <kt-row id="add_access_ip">
                                                <kt-col xs="9" sm="9">
                                                    <kt-form-group>
                                                        <kt-form-control dir="ltr" v-model="new_access_ip"
                                                                         name="new_access_ip"
                                                                         id="new_access_ip"></kt-form-control>
                                                    </kt-form-group>
                                                </kt-col>
                                                <kt-col xs="3" sm="3">
                                                    <kt-form-group hor style="margin-right: 2%">
                                                        <a style="padding-top: 10%" @click="addAccessIp()"
                                                           class="btn btn-bold btn-sm btn-label-brand">
                                                            <i class="la la-plus"></i> {{ $t('btn.add') }}
                                                        </a>
                                                    </kt-form-group>
                                                </kt-col>
                                            </kt-row>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </kt-col>
                        <kt-col xs="4" sm="4">
                            <kt-form-action class="mt-4">
                                <kt-button style="position: absolute;left:5px"
                                           class="m-2 btn-wide"
                                           size="md"
                                           variant="success"
                                           type="button"
                                           v-bind:wide="true"
                                           id="submit_update_application_btn"
                                           @click="updateApplication()"
                                >
                                    {{ $t('btn.edit') }}
                                </kt-button>
                            </kt-form-action>
                        </kt-col>
                    </kt-row>
                </form>
            </kt-panel-body>
        </kt-panel>
        <kt-panel v-if="application.user_type === userTypes.LEGAL">
            <form id="change_application_signature_holders_form">
                <kt-panel-body>
                    <signature-holders :signature_holders="application.signature_holders"></signature-holders>
                    <kt-col xs="4" sm="4">
                        <kt-form-action class="mt-4">
                            <kt-button
                                    style="position: absolute;top:-55px"
                                    class="m-2 btn-wide"
                                    size="md"
                                    variant="success"
                                    type="button"
                                    v-bind:wide="true"
                                    id="submit_update_signature_holders_btn"
                                    @click="updateSignatureHolders()"
                            >
                                {{ $t('btn.edit') }}
                            </kt-button>
                        </kt-form-action>
                    </kt-col>
                </kt-panel-body>
            </form>
        </kt-panel>
        <kt-panel v-if="application">
            <kt-panel-body>
                <kt-row>
                    <p class=" col-lg-10 col-sm-10" style="font-size: medium"> {{ $t('application.app_services') }}</p>
                    <div class="col-lg-2 col-sm-2"
                         style="border-radius: 5px;width: 150px;background-color: #fdffc3">
                        <div style="margin-top: 15px;text-align: center">
                            <p> {{ $t('application.app_service_status') }}</p>
                        </div>
                        <div style="margin-top: 20px">
                            <p> {{ $t('application.service_status.active') }}</p>
                            <i style="position: absolute;left: 9px;top:55px;color: #1dc9b7"
                               class="fa fa-check-circle"></i>
                        </div>
                        <div style="margin-top: 15px">
                            <p> {{ $t('application.service_status.pending') }}</p>
                            <i style="position: absolute;left: 9px;top:91px;color: #f59e00"
                               class="fa fa-exclamation-circle"></i>
                        </div>
                        <div style="margin-top: 15px">
                            <p> {{ $t('application.service_status.blocked') }}</p>
                            <i style="position: absolute;left: 9px;top:125px;color: #ff464a"
                               class="fa fa-ban"></i>
                        </div>
                    </div>
                </kt-row>
                <form id="change_application_services_form"
                      style="margin-top: 10px">
                    <application-services :form_data="application.services"></application-services>
                    <kt-col class="col-12">
                        <kt-form-action class="mt-4">
                            <kt-button
                                    class="m-2 btn-wide"
                                    size="md"
                                    variant="success"
                                    type="button"
                                    v-bind:wide="true"
                                    id="submit_change_services_btn"
                                    @click="changeServices()"
                            >
                                {{ $t('btn.edit') }}
                            </kt-button>
                        </kt-form-action>
                    </kt-col>
                </form>
            </kt-panel-body>
        </kt-panel>
        <kt-panel v-if="application">
            <kt-panel-body>
                <kt-row>
                    <p class=" col-lg-10 col-sm-10" style="font-size: medium"> {{
                            $t('application.account_details')
                        }}</p>
                </kt-row>
                <form id="change_application_bank_accounts_form"
                      style="margin-top: 10px">
                    <edit-application-bank-accounts
                        :application="application"
                    ></edit-application-bank-accounts>
                </form>
            </kt-panel-body>
        </kt-panel>
    </div>
</template>

<script>
import {
    applicationStatusStr, applicationStatus, allApplicationStatuses,
    applicationStatusVariant
} from '@/constants/applicationStatus'
import {applicationServiceStatus, applicationServiceStatusStr,financialServices} from '@/constants/openBanking'
import {KTApp} from "@/plugins/core/app";
import {openBankingService} from "@/common/api.service";
import $ from "jquery";
import toastr from "toastr";
import {i18n} from '@/plugins/i18n';
import {userTypes, userTypesStr} from '@/constants/userTypes'
import {mapGetters} from "vuex";
import ApplicationServices from "../application-services";
import SignatureHolders from "../signature-holders";
import EditApplicationBankAccounts from "@/views/openBanking/components/common-access/edit-application-bank-accounts.vue";

export default {
    components: {EditApplicationBankAccounts, SignatureHolders, ApplicationServices},
    mounted() {
        openBankingService.findApplication(this.hashid).then(response => {
            this.application = response.data.data.application;
            this.application.user_type = this.current_user.user_type
        });
    },
    updated() {
        if (document.getElementById('signature_holder_hr_tag0'))
            document.getElementById('signature_holder_hr_tag0').style.display = 'none'
    },
    data() {
        return {
            applicationStatusStr,
            applicationStatus,
            allApplicationStatuses,
            applicationStatusVariant,
            userTypes,
            applicationServiceStatus,
            applicationServiceStatusStr,
            userTypesStr,
            application: null,
            'hashid': this.$route.params.hashid,
            new_access_ip: null,
            financialServices
        }
    },
    computed: {
        ...mapGetters('user', [
            'current_user'
        ]),
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    methods: {
        updateApplication() {
            let form = $('#update_application_form')
            let btn = $('#submit_update_application_btn')

            form.validate({
                lang: 'fa',
                rules: {
                    title: {
                        required: true
                    },
                    access_ips: {
                        required: () => {
                            if (this.form_data.access_ips.length < 1) return true;
                            else return false
                        },
                    },
                }
            });
            if (!form.valid()) {
                return
            }

            var ip_regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
            for (let i = 0; i < this.application.access_ips.length; i++) {
                if (!ip_regex.test(this.application.access_ips[i]))
                    return this.toastr.error(i18n.t('label.ip')+' '+[i+1]+': '+i18n.t('application.message.invalid_ip_format'))
                let repeat = 0;
                for (var c = 0; c < this.application.access_ips.length; c++) {
                    if (this.application.access_ips[c] === this.application.access_ips[i])
                        repeat++;
                    if (repeat > 1)
                        return this.toastr.error(i18n.t('label.ip')+' '+[i+1]+': '+i18n.t('application.message.ip_is_duplicate'))
                }
            }

            KTApp.progress(btn)

            openBankingService.updateApplication(this.hashid, {
                access_ips: this.application.access_ips,
                title: this.application.title
            }).then(response => {
                this.toastr.success(response.data.message)
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                    if (response.data.data['access_ips.0'] || response.data.data['access_ips.1'] || response.data.data['access_ips.2'] ||
                            response.data.data['access_ips.3'])
                        return this.toastr.error(i18n.t('application.message.invalid_ip_format'))
                }
                this.toastr.error(response.data.message)
            }).finally(() => {
                        KTApp.unprogress(btn)
                    }
            )
        },
        updateSignatureHolders() {
            let btn = $('#submit_update_signature_holders_btn')
            let form = $('#change_application_signature_holders_form')

            if (this.current_user.user_type == userTypes.LEGAL && this.application.signature_holders.length < 1)
                return this.toastr.error(i18n.t('application.message.signature_holder_required'))


            if (this.validateSignatureHolders())
                return;

            KTApp.progress(btn)

            openBankingService.updateApplicationSignatureHolders(this.hashid, {
                signature_holders: this.application.signature_holders
            }).then(response => {
                this.toastr.success(response.data.message)
            }).catch(({response}) => {
                this.toastr.error(response.data.message)
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.toastr.error(response.data.message)
            }).finally(() => {
                        KTApp.unprogress(btn)
                    }
            )
        },
        changeServices() {
            var result = confirm(i18n.t('application.message.change_services_alert'));
            if (!result) return;

            let form = $('#change_application_services_form')
            let btn = $('#submit_change_services_btn')

            for (var prop in this.financialServices){
                if (this.application.services[this.financialServices[prop]].is_selected && this.application.bank_accounts.length < 1) {
                    return this.toastr.error(i18n.t('application.message.minimum_bank_account'))
                }
            }

            KTApp.progress(btn)
            let params = this.getServices()

            openBankingService.changeApplicationServices(this.hashid, params).then(response => {
                for (let key in params) {
                    if (params[key] && this.application.services[key]) {
                        this.application.services[key].is_selected = true;
                        if (!this.application.services[key].status)
                            this.application.services[key].status = this.applicationServiceStatus.PENDING
                    } else
                        this.application.services[key].status = null
                }
                this.toastr.success(response.data.message)
            }) .catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.toastr.error(response.data.message)
            }).finally(() => {
                        KTApp.unprogress(btn)
                    }
            )
        },
        addAccessIp() {
            var ip_regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
            if (!ip_regex.test(this.new_access_ip))
                return this.toastr.error(i18n.t('application.message.invalid_ip_format'))

            for (var i = 0; i < this.application.access_ips.length; i++) {
                if (this.application.access_ips[i] === this.new_access_ip)
                    return this.toastr.error(i18n.t('application.message.ip_is_duplicate'))
            }

            this.application.access_ips.push(this.new_access_ip)
            if (this.application.access_ips.length >= 4)
                document.getElementById('add_access_ip').style.display = 'none'
            this.new_access_ip = null
        },
        deleteAccessIp(index) {
            this.application.access_ips.splice(index, 1)

            if (this.application.access_ips.length < 4)
                document.getElementById('add_access_ip').style.display = 'flex'
        },
        validateSignatureHolders() {
            if (this.current_user.user_type == userTypes.REAL || this.application.signature_holders.length < 1)
                return false;
            let has_error = false;
            for (let i = 0; i < this.application.signature_holders.length; i++) {
                if (!this.application.signature_holders[i].first_name_fa) {
                    document.getElementById('signature_holder_first_name_fa_error' + i).innerText = i18n.t('application.message.field_required')
                    document.getElementById('signature_holder_first_name_fa' + i).style.borderColor = '#fd397a'
                    has_error = true;
                }else if(!this.checkIfIsPersian(this.application.signature_holders[i].first_name_fa)){
                    document.getElementById('signature_holder_first_name_fa_error' + i).innerText = i18n.t('pos.validations.enter_persian')
                    document.getElementById('signature_holder_first_name_fa' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('signature_holder_first_name_fa_error' + i).innerText = ''
                    document.getElementById('signature_holder_first_name_fa' + i).style.borderColor = '#e2e5ec'
                }

                if (!this.application.signature_holders[i].first_name_en) {
                    document.getElementById('signature_holder_first_name_en_error' + i).innerText = i18n.t('application.message.field_required')
                    document.getElementById('signature_holder_first_name_en' + i).style.borderColor = '#fd397a'
                    has_error = true;
                }else if(!this.checkIfIsEnglish(this.application.signature_holders[i].first_name_en)) {
                    document.getElementById('signature_holder_first_name_en_error' + i).innerText = i18n.t('pos.validations.enter_english')
                    document.getElementById('signature_holder_first_name_en' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('signature_holder_first_name_en_error' + i).innerText = ''
                    document.getElementById('signature_holder_first_name_en' + i).style.borderColor = '#e2e5ec'
                }

                if (!this.application.signature_holders[i].last_name_fa) {
                    document.getElementById('signature_holder_last_name_fa_error' + i).innerText = i18n.t('application.message.field_required')
                    document.getElementById('signature_holder_last_name_fa' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else if(!this.checkIfIsPersian(this.application.signature_holders[i].last_name_fa)) {
                    document.getElementById('signature_holder_last_name_fa_error' + i).innerText = i18n.t('pos.validations.enter_persian')
                    document.getElementById('signature_holder_last_name_fa' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('signature_holder_last_name_fa_error' + i).innerText = ''
                    document.getElementById('signature_holder_last_name_fa' + i).style.borderColor = '#e2e5ec'
                }

                if (!this.application.signature_holders[i].last_name_en) {
                    document.getElementById('signature_holder_last_name_en_error' + i).innerText = i18n.t('application.message.field_required')
                    document.getElementById('signature_holder_last_name_en' + i).style.borderColor = '#fd397a'
                    has_error = true;
                }else if(!this.checkIfIsEnglish(this.application.signature_holders[i].last_name_en)) {
                    document.getElementById('signature_holder_last_name_en_error' + i).innerText = i18n.t('pos.validations.enter_english')
                    document.getElementById('signature_holder_last_name_en' + i).style.borderColor = '#fd397a'
                    has_error = true;
                }  else {
                    document.getElementById('signature_holder_last_name_en_error' + i).innerText = ''
                    document.getElementById('signature_holder_last_name_en' + i).style.borderColor = '#e2e5ec'
                }

                if (!this.application.signature_holders[i].father_name_fa) {
                    document.getElementById('signature_holder_father_name_fa_error' + i).innerText = i18n.t('application.message.field_required')
                    document.getElementById('signature_holder_father_name_fa' + i).style.borderColor = '#fd397a'
                    has_error = true;
                }else if(!this.checkIfIsPersian(this.application.signature_holders[i].father_name_fa)) {
                    document.getElementById('signature_holder_father_name_fa_error' + i).innerText = i18n.t('pos.validations.enter_persian')
                    document.getElementById('signature_holder_father_name_fa' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('signature_holder_father_name_fa_error' + i).innerText = ''
                    document.getElementById('signature_holder_father_name_fa' + i).style.borderColor = '#e2e5ec'
                }

                if (!this.application.signature_holders[i].father_name_en) {
                    document.getElementById('signature_holder_father_name_en_error' + i).innerText = i18n.t('application.message.field_required')
                    document.getElementById('signature_holder_father_name_en' + i).style.borderColor = '#fd397a'
                    has_error = true;
                }else if(!this.checkIfIsEnglish(this.application.signature_holders[i].father_name_en)) {
                    document.getElementById('signature_holder_father_name_en_error' + i).innerText = i18n.t('pos.validations.enter_english')
                    document.getElementById('signature_holder_father_name_en' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('signature_holder_father_name_en_error' + i).innerText = ''
                    document.getElementById('signature_holder_father_name_en' + i).style.borderColor = '#e2e5ec'
                }

                if (!this.application.signature_holders[i].birth_date) {
                    document.getElementById('signature_holder_birth_date_error' + i).innerText = i18n.t('application.message.field_required')
                    document.getElementById('signature_holder_birth_date' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('signature_holder_birth_date_error' + i).innerText = ''
                    document.getElementById('signature_holder_birth_date' + i).style.borderColor = '#e2e5ec'
                }

                if (!this.application.signature_holders[i].national_code) {
                    document.getElementById('signature_holder_national_code_error' + i).innerText = i18n.t('application.message.field_required')
                    document.getElementById('signature_holder_national_code' + i).style.borderColor = '#fd397a'
                    has_error = true;
                } else {
                    document.getElementById('signature_holder_national_code_error' + i).innerText = ''
                    document.getElementById('signature_holder_national_code' + i).style.borderColor = '#e2e5ec'
                }
            }

            return has_error;
        },
        getServices() {
            return {
                internal_transfer: this.application.services.internal_transfer.is_selected,
                paya_transfer: this.application.services.paya_transfer.is_selected,
                satna_transfer: this.application.services.satna_transfer.is_selected,
                card_to_iban: this.application.services.card_to_iban.is_selected,
                // card_to_account: this.application.services.card_to_account.is_selected,
                iban_to_account: this.application.services.iban_to_account.is_selected,
                account_to_iban: this.application.services.account_to_iban.is_selected,
                invoice: this.application.services.invoice.is_selected,
                // satna_report: this.application.services.satna_report.is_selected,
                // paya_report: this.application.services.paya_report.is_selected,
                matching_national_id_mobile: this.application.services.matching_national_id_mobile.is_selected,
                // postal_code_information: this.application.services.postal_code_information.is_selected,
                iban_inquiry: this.application.services.iban_inquiry.is_selected,
                // card_owner_information_inquiry: this.application.services.card_owner_information_inquiry.is_selected,
                // account_owner_name_inquiry: this.application.services.account_owner_name_inquiry.is_selected,
                // card_inquiry: this.application.services.card_inquiry.is_selected,
                matching_card_national_id_birth_date_inquiry: this.application.services.matching_card_national_id_birth_date_inquiry.is_selected,
                matching_iban_national_id_birth_date_inquiry: this.application.services.matching_iban_national_id_birth_date_inquiry.is_selected,
                matching_iban_national_id_inquiry: this.application.services.matching_iban_national_id_inquiry.is_selected,
                balance: this.application.services.balance.is_selected,
                vital_info: this.application.services.vital_info.is_selected,
            }
        },
    }
}
</script>

<style>
.modal .modal-content .modal-header .close:before {
    content: "" !important;
}

.modal .modal-content .modal-header .close {
    font-size: 1.8rem;
    line-height: .7;
}
</style>